export default function Contact() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="company_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      return;
    }
    const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = '正在提交...';
    }
    try {
      const formData = new FormData(form);
      if (honeypot) formData.delete('company_alt');
      const resp = await fetch('https://readdy.ai/api/form/d9lfp8e8mbnljin59cig', { method: 'POST', body: formData });
      const respText = await resp.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(respText); } catch { /* ignore */ }
      if (resp.ok && parsed?.code === 'OK') {
        form.reset();
        const msg = document.getElementById('contact-success-msg');
        if (msg) msg.style.display = 'block';
      } else {
        const err = document.getElementById('contact-error-msg');
        if (err) {
          err.style.display = 'block';
          const serverMsg = (parsed?.meta as Record<string, string>)?.message || '';
          if (serverMsg) err.textContent = serverMsg;
        }
      }
    } catch {
      const err = document.getElementById('contact-error-msg');
      if (err) err.style.display = 'block';
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = '提交信息';
      }
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            联络我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">联系我们</h2>
          <p className="text-sm text-foreground-500 mt-2">有料就爆，有瓜就投，你的线索我们很感兴趣</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex-1">
              <form onSubmit={handleSubmit} data-readdy-form="">
                <div className="space-y-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">你的昵称</label>
                    <input id="contact-name" name="name" type="text" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors" placeholder="请输入昵称" />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                    <input id="contact-email" name="email" type="email" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors" placeholder="请输入邮箱" />
                  </div>
                  <div>
                    <label htmlFor="contact-topic" className="block text-sm font-medium text-foreground-700 mb-1.5">爆料主题</label>
                    <input id="contact-topic" name="topic" type="text" required className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors" placeholder="请输入主题" />
                  </div>
                  <div>
                    <label htmlFor="contact-detail" className="block text-sm font-medium text-foreground-700 mb-1.5">详细描述</label>
                    <textarea id="contact-detail" name="detail" required maxLength={500} rows={4} className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none" placeholder="请详细描述你想爆料的八卦内容..."></textarea>
                  </div>
                  <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
                  <button type="submit" className="w-full py-2.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    提交信息
                  </button>
                  <p id="contact-success-msg" className="text-sm text-primary-600 font-medium text-center hidden">投稿提交成功！我们会尽快处理。</p>
                  <p id="contact-error-msg" className="text-sm text-primary-600 font-medium text-center hidden">提交失败，请稍后再试。</p>
                </div>
              </form>
            </div>
            <div className="lg:w-64 shrink-0 space-y-4">
              <div className="p-4 rounded-xl bg-primary-50/70">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-2">
                  <i className="ri-mail-line"></i>
                </div>
                <h4 className="font-heading text-sm text-foreground-900 mb-1">投稿邮箱</h4>
                <p className="text-xs text-foreground-500">tips@52chigua.com</p>
              </div>
              <div className="p-4 rounded-xl bg-accent-50/70">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-2">
                  <i className="ri-wechat-line"></i>
                </div>
                <h4 className="font-heading text-sm text-foreground-900 mb-1">微信联系</h4>
                <p className="text-xs text-foreground-500">搜索关注「52吃瓜网」</p>
              </div>
              <div className="p-4 rounded-xl bg-secondary-50/70">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-2">
                  <i className="ri-shield-check-line"></i>
                </div>
                <h4 className="font-heading text-sm text-foreground-900 mb-1">隐私保护</h4>
                <p className="text-xs text-foreground-500">所有爆料信息严格保密</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}